import React from "react";
import { StyledOption, StyledOptionPrefix, StyledOptionTitle, StyledOptionPrimarySubtitle, StyledOptionSecondarySubtitle } from "./styles";
export const formatOptionContent = (props) => {
    const { context, option, prefixFormatter, primarySubtitleFormatter, secondarySubtitleFormatter, titleFormatter, valueFormatter, } = props;
    const formatValue = (formatter, defaultValue = "") => {
        const value = formatter
            ? formatter({
                value: option,
                context: context,
            })
            : defaultValue;
        // TODO: Is the check for null necessary?
        return value && value != null && value !== "" ? value : undefined;
    };
    const prefix = formatValue(prefixFormatter);
    const title = formatValue(titleFormatter ?? valueFormatter, option.label);
    const primarySubtitle = primarySubtitleFormatter ? formatValue(primarySubtitleFormatter) : null;
    const secondarySubtitle = secondarySubtitleFormatter ? formatValue(secondarySubtitleFormatter) : null;
    return { prefix, title, primarySubtitle, secondarySubtitle };
};
/**
 * The default component for rendering an option in the Selector
 *
 * @param   option  The option to render
 * @param   context The context for this option to pass to the valueFormatter
 * @param   valueFormatter  An instance of a Capn tValueFormatter used to specify the value of the option
 * @param   prefixFormatter An instance of a Capn tValueFormatter that can add a prefix to the text of the option
 * @param   titleFormatter The Capn tValueFormatter that formats the main title of the option. If one is not
 *                          provided, the display resorts to the valueFormatter
 * @param   primarySubtitleFormatter  An instance of a Capn tValueFormatter that displays additional properties of the
 *                          object represented by the option
 * @param   secondarySubtitleFormatter  An instance of a Capn tValueFormatter that displays more additional properties
 *                           of the object represented by the option
 * @returns The rendered option for the selector
 */
const SelectorOption = props => {
    const { prefix, title, primarySubtitle, secondarySubtitle } = formatOptionContent(props);
    return (React.createElement(StyledOption, { className: "option-content" },
        prefix ? React.createElement(StyledOptionPrefix, null, prefix) : null,
        title ? React.createElement(StyledOptionTitle, null, title) : null,
        primarySubtitle ? React.createElement(StyledOptionPrimarySubtitle, null, primarySubtitle) : null,
        secondarySubtitle ? React.createElement(StyledOptionSecondarySubtitle, null, secondarySubtitle) : null));
};
export default SelectorOption;
